/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BorrowerHeaderTabDto
 */
export interface BorrowerHeaderTabDto {
    /**
     * 
     * @type {string}
     * @memberof BorrowerHeaderTabDto
     */
    borrowerId: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerHeaderTabDto
     */
    fullName: string;
}

/**
 * Check if a given object implements the BorrowerHeaderTabDto interface.
 */
export function instanceOfBorrowerHeaderTabDto(value: object): value is BorrowerHeaderTabDto {
    if (!('borrowerId' in value) || value['borrowerId'] === undefined) return false;
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    return true;
}

export function BorrowerHeaderTabDtoFromJSON(json: any): BorrowerHeaderTabDto {
    return BorrowerHeaderTabDtoFromJSONTyped(json, false);
}

export function BorrowerHeaderTabDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerHeaderTabDto {
    if (json == null) {
        return json;
    }
    return {
        
        'borrowerId': json['borrowerId'],
        'fullName': json['fullName'],
    };
}

export function BorrowerHeaderTabDtoToJSON(json: any): BorrowerHeaderTabDto {
    return BorrowerHeaderTabDtoToJSONTyped(json, false);
}

export function BorrowerHeaderTabDtoToJSONTyped(value?: BorrowerHeaderTabDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'borrowerId': value['borrowerId'],
        'fullName': value['fullName'],
    };
}

